import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OtherKpMainTableComponent } from './component/other-kp-main/other-kp-main-table.component';


const routes: Routes = [
  {
    path: '',
    component: OtherKpMainTableComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OtherKpPageRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/other-kp-page-routing.module.ts